import React, { useState, useEffect } from 'react';
import './Navbar.css';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';

const Navbar = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showOptions, setShowOptions] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobileView = windowWidth < 600;

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  return (
    <div>
      <div className='card12'>
      {!isMobileView && (
        <input className='searching' type='search' style={{ paddingLeft: '45px' }} />
      )}
        <div className='search'>
          <SearchIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"},
          color: isMobileView ? '#004F95' : 'inherit'
        }}
           />
        </div>
      </div>
      {!isMobileView && (
        <>
          <div className='btn'>
            <button> Add New</button>
          </div>
          <div className='btn2'>
            <button> Sign In</button>
          </div>
          <div className='btn3'>
            <button> Sign Up</button>
          </div>
        </>
      )}
      <div className={`plus ${isMobileView ? 'show' : ''}`}>
        <AddCircleOutlineIcon
        sx={{
          width: { xl: "27px", lg: "27px", md: "25px", sm: "20px", },
          height: { xl: "31px", lg: "31px", md: "38px", sm: "24px", },
          fontSize: {xs: "20px"},
          color: isMobileView ? '#004F95' : 'inherit'
        }}
         />
      </div>
      {isMobileView && (
        <div className='person_1' onClick={toggleOptions}>
          <Person2OutlinedIcon
          sx={{
            width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
            height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
            fontSize: {xs: "20px"},
            color: isMobileView ? '#004F95' : 'inherit'
          }} />
          {showOptions && (
            <div className='options'>
              <button>Sign In</button>
            </div>
          )}
          {showOptions && (
            <div className='options'>
              <button>SignUp</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Navbar;
